<script>
import db from '@/mixins/db'
import { mapGetters } from 'vuex'
import { getAreaPois } from './service'
import { requestPois } from './service/utils'
export default {
  name: 'AtlasPois',
  mixins: [db],
  render () {
    return null
  },
  data () {
    return {
      ready: false,
      areas: []
    }
  },
  computed: {
    ...mapGetters({
      center: 'map/center',
      zoom: 'map/zoom',
      allDocs: 'db/allDocs'
    })
  },
  watch: {
    center (val) {
      if (this.ready && requestPois(val, this.areas)) this.getPois(val)
    }
  },
  methods: {
    getAreas () {
      this.allDocs('area').then(coll => {
        this.areas = coll.rows.map(r => r.doc)
        this.ready = true
      })
    },
    getPois (coords) {
      this.ready = false
      // load pois only if the map is zoomed enough
      if (this.zoom > 11) {
        getAreaPois(coords).then(res => {
          if (res.area) {
            this.saveDoc('area', res.area).then(() => {
              this.getAreas()
            })
          } else {
            this.ready = true
          }
          this.saveDocs(res.pois).catch(err => {
            console.log(err)
          })
        })
      }
    }
  },
  created () {
    this.getAreas()
  }
}
</script>
